import { fetcher } from '@commenda/utils';

const DOCUMENT_GENERATION_BASE_URL = 'document-generation';

export async function documentPayloadPreview(data: {
  companyId: number;
  documentTemplateId: string;
  entitySelections: Record<string, string>;
  inputs?: Record<string, string>;
}): Promise<{
  success: boolean;
  data?: { renderContext: Record<string, unknown> };
}> {
  try {
    const res = await fetcher(
      `${DOCUMENT_GENERATION_BASE_URL}/payload-preview`,
      {
        method: 'POST',
        body: data,
      }
    );
    if (!res.ok) return { success: false, data: undefined };
    const responseData = (await res.json()) as {
      renderContext: Record<string, unknown>;
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
